import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Blur from './Blur';
import close from '@design-system/Assets/close.svg';

const Sidemodal = styled.div`
  color: #000;
  position: fixed;
  z-index: 500;
  width: 318px;
  height: 100vh;
  box-sizing: border-box;
  background: #fff;
  display: inline-block;
  box-shadow: 2px 0px 4px rgba(158, 158, 158, 0.4);
  top: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};

  @media screen and (max-width: 768px) {
    width: 318px;
  }

  .box {
    padding: 20px;
  }

  .close {
    position: absolute;
    left: -30%;
    top: 10%;
    zindex: 600;
    cursor: pointer;
  }
`;

const SideModal = ({ isOpen, toggle, children, ...props }) => {
  return (
    <div>
      <Blur isOpen={isOpen} toggle={toggle} />
      <Sidemodal isOpen={isOpen} {...props}>
        <div className="close">
          <img src={close} alt="close" onClick={toggle} />
        </div>
        {children}
      </Sidemodal>
    </div>
  );
};

export default SideModal;

SideModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

SideModal.defaultProps = {
  toggle: () => {},
};
